// CloudSecurityPage.js
import React from 'react';
import styles from './CloudSecurityPage.module.css';

const CloudSecurityPage = () => {
  return (
    <div className={styles.cloudSecurityPage}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroBackground}>
          <div className={styles.heroPattern}></div>
          <div className={styles.heroElements}>
            <div className={styles.networkNodes}>
              <div className={styles.node}></div>
              <div className={styles.node}></div>
              <div className={styles.node}></div>
              <div className={styles.node}></div>
            </div>
            <div className={styles.connectionLines}>
              <div className={styles.line}></div>
              <div className={styles.line}></div>
              <div className={styles.line}></div>
            </div>
            <div className={styles.dataStreams}>
              <div className={styles.stream}></div>
              <div className={styles.stream}></div>
            </div>
          </div>
        </div>
        <div className={styles.heroContainer}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>Cloud Security Services</h1>
            <p className={styles.heroDescription}>
              As more businesses migrate to the cloud, Virtual IP ensures your 
              cloud infrastructure remains resilient against unauthorized access, 
              breaches, and advanced cyber threats. Our Cloud Security Services 
              offer comprehensive protection—from secure design to continuous 
              monitoring—ensuring your data and applications stay safe across all 
              major cloud platforms.
            </p>
          </div>
          <div className={styles.heroVisual}>
            <div className={styles.cloudInfrastructure}>
              <div className={styles.mainCloud}>
                <div className={styles.cloudBase}></div>
                <div className={styles.cloudHighlight}></div>
              </div>
              <div className={styles.platformElements}>
                <div className={styles.platform1}>
                  <div className={styles.platformBase}></div>
                  <div className={styles.platformScreen}></div>
                </div>
                <div className={styles.platform2}>
                  <div className={styles.platformBase}></div>
                  <div className={styles.platformScreen}></div>
                </div>
                <div className={styles.platform3}>
                  <div className={styles.platformBase}></div>
                  <div className={styles.platformScreen}></div>
                </div>
                <div className={styles.platform4}>
                  <div className={styles.platformBase}></div>
                  <div className={styles.platformScreen}></div>
                </div>
              </div>
              <div className={styles.dataConnections}>
                <div className={styles.dataFlow1}></div>
                <div className={styles.dataFlow2}></div>
                <div className={styles.dataFlow3}></div>
                <div className={styles.dataFlow4}></div>
              </div>
              <div className={styles.floatingElements}>
                <div className={styles.floatingIcon1}></div>
                <div className={styles.floatingIcon2}></div>
                <div className={styles.floatingIcon3}></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Secure Cloud Infrastructure Design Section */}
      <section className={styles.infrastructureSection}>
        <div className={styles.container}>
          <div className={styles.sectionGrid}>
            <div className={styles.sectionContent}>
              <h2 className={styles.sectionTitle}>
                Secure Cloud Infrastructure Design
              </h2>
              <div className={styles.titleUnderline}></div>
              <p className={styles.sectionDescription}>
                We help you build cloud environments with security 
                at the core. Virtual IP architects virtual private clouds 
                (VPCs), enforces strong access controls, and 
                integrates advanced security configurations to 
                minimize risk exposure and ensure data 
                confidentiality.
              </p>
            </div>
            <div className={styles.sectionVisual}>
              <div className={styles.infrastructureIllustration}>
                <div className={styles.cloudNetwork}>
                  <div className={styles.centralCloud}>
                    <div className={styles.cloudIcon}>
                      <div className={styles.cloudBody}></div>
                      <div className={styles.wifiSignal}>
                        <div className={styles.signal1}></div>
                        <div className={styles.signal2}></div>
                        <div className={styles.signal3}></div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.serverClusters}>
                    <div className={styles.serverCluster1}>
                      <div className={styles.server}></div>
                      <div className={styles.server}></div>
                      <div className={styles.server}></div>
                    </div>
                    <div className={styles.serverCluster2}>
                      <div className={styles.server}></div>
                      <div className={styles.server}></div>
                      <div className={styles.server}></div>
                    </div>
                  </div>
                  <div className={styles.satelliteClouds}>
                    <div className={styles.satelliteCloud1}>
                      <div className={styles.miniCloud}></div>
                      <div className={styles.miniWifi}></div>
                    </div>
                    <div className={styles.satelliteCloud2}>
                      <div className={styles.miniCloud}></div>
                      <div className={styles.miniWifi}></div>
                    </div>
                    <div className={styles.satelliteCloud3}>
                      <div className={styles.miniCloud}></div>
                      <div className={styles.miniWifi}></div>
                    </div>
                  </div>
                  <div className={styles.networkConnections}>
                    <div className={styles.networkLine}></div>
                    <div className={styles.networkLine}></div>
                    <div className={styles.networkLine}></div>
                    <div className={styles.networkLine}></div>
                    <div className={styles.networkLine}></div>
                    <div className={styles.networkLine}></div>
                  </div>
                  <div className={styles.globalNodes}>
                    <div className={styles.globalNode}></div>
                    <div className={styles.globalNode}></div>
                    <div className={styles.globalNode}></div>
                    <div className={styles.globalNode}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Identity & Access Management Section */}
      <section className={styles.iamSection}>
        <div className={styles.container}>
          <div className={styles.sectionGrid}>
            <div className={styles.sectionVisual}>
              <div className={styles.iamIllustration}>
                <div className={styles.iamNetwork}>
                  <div className={styles.networkMap}>
                    <div className={styles.mapBase}></div>
                    <div className={styles.circuitPaths}>
                      <div className={styles.circuitPath}></div>
                      <div className={styles.circuitPath}></div>
                      <div className={styles.circuitPath}></div>
                      <div className={styles.circuitPath}></div>
                    </div>
                    <div className={styles.accessPoints}>
                      <div className={styles.accessPoint}></div>
                      <div className={styles.accessPoint}></div>
                      <div className={styles.accessPoint}></div>
                      <div className={styles.accessPoint}></div>
                      <div className={styles.accessPoint}></div>
                      <div className={styles.accessPoint}></div>
                      <div className={styles.accessPoint}></div>
                      <div className={styles.accessPoint}></div>
                    </div>
                    <div className={styles.securityLocks}>
                      <div className={styles.securityLock}></div>
                      <div className={styles.securityLock}></div>
                      <div className={styles.securityLock}></div>
                    </div>
                    <div className={styles.dataBlocks}>
                      <div className={styles.dataBlock}></div>
                      <div className={styles.dataBlock}></div>
                    </div>
                    <div className={styles.alertIcons}>
                      <div className={styles.alertIcon}></div>
                      <div className={styles.alertIcon}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.sectionContent}>
              <h2 className={styles.sectionTitle}>
                Robust Identity & Access Management (IAM)
              </h2>
              <div className={styles.titleUnderline}></div>
              <p className={styles.sectionDescription}>
                Control who gets access and what they can do. Virtual 
                IP implements IAM best practices such as multi-factor authentication (MFA), role-based access control 
                (RBAC), and single sign-on (SSO) to secure user 
                identities and prevent unauthorized access to 
                sensitive cloud assets.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Real-time Monitoring Section */}
      <section className={styles.monitoringSection}>
        <div className={styles.container}>
          <div className={styles.sectionGrid}>
            <div className={styles.sectionContent}>
              <h2 className={styles.sectionTitle}>
                Real-time Monitoring & Threat Detection
              </h2>
              <div className={styles.titleUnderline}></div>
              <p className={styles.sectionDescription}>
                Our cloud security experts monitor your cloud 
                resources 24/7 using cloud-native tools and threat 
                intelligence platforms. We detect anomalies, 
                misconfigurations, and suspicious behaviors in real-time to mitigate risks before they escalate into 
                breaches.
              </p>
            </div>
            <div className={styles.sectionVisual}>
              <div className={styles.monitoringIllustration}>
                <div className={styles.monitoringStack}>
                  <div className={styles.stackLayer1}>
                    <div className={styles.layerBase}></div>
                    <div className={styles.layerElements}>
                      <div className={styles.layerElement}></div>
                      <div className={styles.layerElement}></div>
                    </div>
                  </div>
                  <div className={styles.stackLayer2}>
                    <div className={styles.layerBase}></div>
                    <div className={styles.layerElements}>
                      <div className={styles.layerElement}></div>
                      <div className={styles.layerElement}></div>
                    </div>
                  </div>
                  <div className={styles.stackLayer3}>
                    <div className={styles.layerBase}></div>
                    <div className={styles.layerElements}>
                      <div className={styles.layerElement}></div>
                      <div className={styles.layerElement}></div>
                    </div>
                  </div>
                  <div className={styles.stackLayer4}>
                    <div className={styles.layerBase}></div>
                    <div className={styles.layerElements}>
                      <div className={styles.layerElement}></div>
                      <div className={styles.layerElement}></div>
                    </div>
                  </div>
                  <div className={styles.stackLayer5}>
                    <div className={styles.layerBase}></div>
                    <div className={styles.layerElements}>
                      <div className={styles.layerElement}></div>
                      <div className={styles.layerElement}></div>
                    </div>
                  </div>
                  <div className={styles.monitoringEyes}>
                    <div className={styles.eye1}></div>
                    <div className={styles.eye2}></div>
                    <div className={styles.eye3}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Compliance-Driven Cloud Governance Section */}
      <section className={styles.governanceSection}>
        <div className={styles.container}>
          <div className={styles.sectionGrid}>
            <div className={styles.sectionVisual}>
              <div className={styles.governanceIllustration}>
                <div className={styles.governanceEnvironment}>
                  <div className={styles.mainCloud}>
                    <div className={styles.cloudShape}></div>
                    <div className={styles.cloudConnections}>
                      <div className={styles.connection1}></div>
                      <div className={styles.connection2}></div>
                      <div className={styles.connection3}></div>
                      <div className={styles.connection4}></div>
                    </div>
                  </div>
                  <div className={styles.workstations}>
                    <div className={styles.workstation1}>
                      <div className={styles.screen}></div>
                      <div className={styles.screenContent}></div>
                    </div>
                    <div className={styles.workstation2}>
                      <div className={styles.screen}></div>
                      <div className={styles.screenContent}></div>
                    </div>
                    <div className={styles.workstation3}>
                      <div className={styles.screen}></div>
                      <div className={styles.screenContent}></div>
                    </div>
                  </div>
                  <div className={styles.teamMembers}>
                    <div className={styles.teamMember1}>
                      <div className={styles.memberBody}></div>
                      <div className={styles.memberHead}></div>
                    </div>
                    <div className={styles.teamMember2}>
                      <div className={styles.memberBody}></div>
                      <div className={styles.memberHead}></div>
                    </div>
                    <div className={styles.teamMember3}>
                      <div className={styles.memberBody}></div>
                      <div className={styles.memberHead}></div>
                    </div>
                  </div>
                  <div className={styles.documentElements}>
                    <div className={styles.document}></div>
                    <div className={styles.magnifyingGlass}></div>
                    <div className={styles.charts}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.sectionContent}>
              <h2 className={styles.sectionTitle}>
                Compliance-Driven Cloud Governance
              </h2>
              <div className={styles.titleUnderline}></div>
              <p className={styles.sectionDescription}>
                Virtual IP ensures your cloud environment aligns with 
                frameworks like ISO 27001, SOC 2, and CIS 
                benchmarks. We conduct cloud security audits and 
                provide risk reports that help you stay compliant and 
                audit-ready, even in heavily regulated industries.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CloudSecurityPage;